import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderReferralLogAppResource from "./ServiceProviderReferralLogAppResource";

export const CALL_TO_ACTION = '7256a780-6673-4f5c-9bcb-b34efa7cb0e4';
export const PHONE_LINK = '702da743-7521-4938-bec5-019b005231ad';
export const MESSAGE = '7e4d7d51-f47b-475c-9a4b-d10c393cf9b0';
export const SERVICE_REQUEST = 'cb918198-b164-4f17-802c-c8680440f996';
export const WEBSITE_LINK = 'b696db5f-0fac-40eb-b34b-3c1cae178458';

class ServiceProviderReferralTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-referral-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/referrals/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'referralLogs',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            referralLogs: ServiceProviderReferralLogAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default ServiceProviderReferralTypeAppResource;
